import type {
  IngredientOption,
  IngredientOptionTranslations,
  RecipeSlot,
  Unit,
} from "../../domain/types";

/**
 * Egg options must set `instructionValues.safetyCue` to a doneness phrase and
 * reference `{slot.safetyCue}` in at least one step. See `IngredientOption`.
 */
export function option(
  ingredientId: string,
  quantity: number,
  unit: Unit,
  preparation?: string,
  editorialPriority = 1,
  instructionValues?: Record<string, string>,
  translations?: IngredientOptionTranslations,
): IngredientOption {
  return {
    ingredientId,
    quantity,
    unit,
    preparation,
    editorialPriority,
    instructionValues,
    translations,
  };
}

export function slot(
  id: string,
  label: string,
  required: boolean,
  canonicalIngredientId: string,
  options: IngredientOption[],
): RecipeSlot {
  return { id, label, required, canonicalIngredientId, options };
}

export const pantry = {
  water: (ml: number) =>
    slot("water", "Water", true, "water", [option("water", ml, "ml")]),
  salt: slot("salt", "Salt", true, "salt", [option("salt", 2, "pinch")]),
  pepper: slot("black-pepper", "Black pepper", true, "black-pepper", [
    option("black-pepper", 1, "pinch"),
  ]),
};
